import React from 'react'
import isFunction from 'lodash/isFunction'
import { compose, withState, mapProps } from 'recompose'

const withTempAction = () => compose(
  withState('tempState', 'setTempState', false),
  withState('tempContent', 'setTempContent', ''),
  withState('submitAction', 'storeTempAction', (props) => () => {}),
  mapProps(({
    submitAction,
    setTempState,
    storeTempAction,
    setTempContent,
    ...props,
  }) => ({
    submitAction,
    onOpenTempState: ({ action, content }) => {
      if(isFunction(action)){
        const onSubmitAction = (...args) => {
          action(...args)
          return setTempState(false)
        }
        storeTempAction(() => onSubmitAction)
        setTempContent(content)
      }
      return setTempState(true)
    },
    onCloseTempState: () => setTempState(false),
    ...props,
  }))
)

export default withTempAction



// WEBPACK FOOTER //
// ./src/hocs/bases/withTempAction.js